import { render, staticRenderFns } from "./YzRadioGroup.vue?vue&type=template&id=4b0614b6&lang=pug&"
import script from "./YzRadioGroup.vue?vue&type=script&lang=js&"
export * from "./YzRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports